import http from "../../http-common"

class ArticlesFilteredServices {
    getAllArticlesFiltereds(categoryId: string,isInclude: boolean, noOfArticles: number ) {
        return http.get(`/articles/filtered?listOfCategoryId=${categoryId}&toInclude=${isInclude}&numberOfArticles=${noOfArticles}`)
    }
}


export default new ArticlesFilteredServices();